import {
  getByIdPlanSelector,
  PLAN_KEY
} from '@gymaholic/packages'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import { logUtil } from 'packages/src'
import React from 'react'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import MediaImage from 'containers/MediaImage'
import getNameReduxUtil from 'modules/redux/utils/get-name'

/**
 * @param props
 * @param props.id
 * @param props.aspectRatio
 * @param props.fallbackImage
 * @param props.shouldDirectlyLoadTheSrcIfFallback
 * @param props.imgStyle
 * @returns {JSX.Element}
 * @constructor
 */
export default function PlanMediaImage (props) {
  const {
    id,
    ...rest
  } = props
  const instance = useSelector(getByIdPlanSelector(id))

  const debugProps = {
    id,
    instance,
    props
  }

  logUtil('PlanMediaImage').debug('[start] debugProps=', debugProps)

  if (!instance) {
    logUtil('PlanMediaImage').debug('[noop] instance not defined')
    return <></>
  }

  return (
    <MediaImage
      id={getValueReduxUtil(instance, PLAN_KEY.MEDIA_ID)}
      alt={getNameReduxUtil(instance)}
      {...rest}
    />
  )
}
